// WorkflowAccomplishmentService.js
// Fire-and-forget stamp for type-bag workflow templates (base-scoped uses the
// `_workflowTemplates` trigger).

import { functions, httpsCallable } from 'firebaseConfig';

const stampWorkflowAccomplishmentPhrases = httpsCallable(
  functions,
  'stampWorkflowAccomplishmentPhrases',
);

function normalizeString(value) {
  return String(value || '').trim();
}

/**
 * Request accomplishment phrases after a workflow template save.
 * Does not throw; save already succeeded.
 *
 * @param {object} params
 * @param {string} params.baseKey
 * @param {string} [params.typeKey]
 * @param {string} [params.templateKey]
 * @param {boolean} [params.backfill]
 * @returns {void}
 */
export function requestWorkflowAccomplishmentPhrases({
  baseKey,
  typeKey,
  templateKey,
  backfill = false,
} = {}) {
  const cleanedBaseKey = normalizeString(baseKey);
  if (!cleanedBaseKey) return;

  void stampWorkflowAccomplishmentPhrases({
    baseKey: cleanedBaseKey,
    typeKey: normalizeString(typeKey) || null,
    templateKey: normalizeString(templateKey) || null,
    backfill: backfill === true,
  }).catch((error) => {
    console.warn('[WorkflowAccomplishment] stamp failed', error);
  });
}
